<template>
  <right-menu-item
    v-if="show"
    @click.stop.prevent="click"
    :class="{ 'muted': !isActive }"
    :text="$t('Show overviews')"
    icon="info"
  />
</template>

<script>
import { mapStores } from 'pinia'
import useBcOverviewsModalStore from '@/frontapp/store/bcOverviewsModal'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import useBcFolderStore from '@/frontapp/store/bcFolder'
import DocumentStore from '@/frontapp/mixins/DocumentStore'

export default {
  mixins: [
    DocumentStore,
  ],
  computed: {
    ...mapStores(useBcOverviewsModalStore, useBcSelectedStore, useBcFolderStore),
    show () {
      return this.isFolder
          || (this.isDocument && this.bcDocumentStore.document?.can_download)
    },
    isDocument() {
      const routesDocument = [
        'BCDocument', 
        'BCDocumentDetail', 
        'BCDocumentDetailRev',
      ]

      if (routesDocument.includes(this.$route.matched[0].name)) {
        return true
      }

      return false
    },
    isDocumentSelected() {
      const routesFolder = [
        'BCFolder', 
        'BCHome',
      ]

      if (routesFolder.includes(this.$route.matched[0].name) && this.bcSelectedStore.listSelected.length === 1 && this.bcSelectedStore.listSelected[0].type === 'document') {
        return true
      }

      return false
    },
    isFolder() {
      const routesFolder = [
        'BCFolder',
        'BCHome',
      ]

      if (routesFolder.includes(this.$route.matched[0].name)) {
        return true
      }

      return false
    },
    isFolderSelected() {
      const routesFolder = [
        'BCFolder', 
        'BCHome',
      ]

      if (routesFolder.includes(this.$route.matched[0].name) && this.bcSelectedStore.listSelected.length === 1 && this.bcSelectedStore.listSelected[0].type === 'folder') {
        return true
      }

      return false
    },
    isActive() {
      return this.isDocument // v dokumentu kde muzu stahovat - osetreno v show
        || (this.isFolder && this.isDocumentSelected && this.bcFolderStore.current?.can_download) // oznaceny dokument ve slozce kde muzu stahovat
        || (this.isFolder && !this.isDocumentSelected && !this.isFolderSelected && this.bcFolderStore.current?.can_download && this.bcFolderStore.current?.id) // aktualni slozka kde muzu stahovat a nejedna se o root
        || (this.isFolder && this.isFolderSelected && this.bcSelectedStore.listSelected[0].can_download) // oznacena slozka ve ktere stahovat
      
      //(this.isDocument || this.isDocumentSelected || this.isFolder || this.isFolderSelected)
    },
  },
  methods: {
    click() {
      let id, type

      if (this.isDocument) {
        id = parseInt(this.$route.params.id)
        type = 'document'
      } else if (this.isDocumentSelected) {
        id = this.bcSelectedStore.listSelected[0].id
        type = 'document'
      } else if (this.isFolderSelected) {
        id = this.bcSelectedStore.listSelected[0].id
        type = 'folder'
      } else if (this.isFolder) {
        id = parseInt(this.bcFolderStore.current.id)
        type = 'folder'
      }

      this.bcOverviewsModalStore.openModal(id, type)
    }
  }
}
</script>

<style lang="scss" scoped></style>
